import type { BadgeColor } from '@ksyos/design-system';
import { PatientPresence } from '@common/customControls/bariatrics';

export const patientPresenceWithColor: { color: BadgeColor; value: PatientPresence }[] = [
    {
        color: 'green',
        value: PatientPresence.present,
    },
    {
        color: 'orange',
        value: PatientPresence.notPresent,
    },
];
